import { render, staticRenderFns } from "./ContestOfferView.vue?vue&type=template&id=188c28cf&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./ContestOfferView.vue?vue&type=script&lang=js&"
export * from "./ContestOfferView.vue?vue&type=script&lang=js&"
import style0 from "./ContestOfferView.vue?vue&type=style&index=0&id=188c28cf&scoped=true&lang=css&"
import style1 from "./ContestOfferView.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188c28cf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VStepper } from 'vuetify/lib'
import { VStepperHeader } from 'vuetify/lib'
import { VStepperItems } from 'vuetify/lib'
import { VStepperStep } from 'vuetify/lib'
installComponents(component, {VAlert,VBtn,VFlex,VIcon,VLayout,VSpacer,VStepper,VStepperHeader,VStepperItems,VStepperStep})
